'use strict';
(function () {
  var header = document.querySelector('.mdhb');
  if (!header) return;

  /* ---- Scroll: collapse announce bar ---- */
  var onScroll = function () {
    var scrolled = window.scrollY > 30;
    header.classList.toggle('is-scrolled', scrolled);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Mega menu: L2 hover swaps the visible L3 group ---- */
  header.querySelectorAll('.mdhb-mega').forEach(function (mega) {
    var l2Links = mega.querySelectorAll('.mdhb-mega__l2-link');
    var l3Groups = mega.querySelectorAll('.mdhb-mega__l3-group');
    // Snapshot the Liquid-rendered default so we can restore it on close.
    var defaultActive = mega.querySelector('.mdhb-mega__l2-link.is-active');
    mega.__mdhbDefaultIdx = defaultActive ? defaultActive.getAttribute('data-l2-index') : null;

    l2Links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        var hasL3 = link.getAttribute('data-has-l3') === 'true';
        var idx = link.getAttribute('data-l2-index');
        l2Links.forEach(function (l) { l.classList.toggle('is-active', l === link && hasL3); });
        l3Groups.forEach(function (g) {
          g.classList.toggle('is-active', hasL3 && g.getAttribute('data-l3-group') === idx);
        });
      });
    });
  });

  /* ---- Desktop mega menu open/close ---- */
  var navItems = header.querySelectorAll('.mdhb-nav__item');
  var restoreDefault = function (item) {
    var mega = item.querySelector('.mdhb-mega');
    if (!mega) return;
    var idx = mega.__mdhbDefaultIdx;
    mega.querySelectorAll('.mdhb-mega__l2-link').forEach(function (l) {
      l.classList.toggle('is-active', l.getAttribute('data-l2-index') === idx && l.classList.contains('has-l3'));
    });
    mega.querySelectorAll('.mdhb-mega__l3-group').forEach(function (g) {
      g.classList.toggle('is-active', g.getAttribute('data-l3-group') === idx);
    });
  };
  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      navItems.forEach(function (i) {
        if (i !== item) { i.classList.remove('is-open'); restoreDefault(i); }
      });
      item.classList.add('is-open');
    });
  });
  var desktopBar = header.querySelector('.mdhb-bar--desktop');
  if (desktopBar) {
    desktopBar.addEventListener('mouseleave', function () {
      navItems.forEach(function (i) { i.classList.remove('is-open'); restoreDefault(i); });
    });
  }

  /* ---- Mobile burger / drawer ---- */
  var burger = header.querySelector('.mdhb-burger');
  var drawer = header.querySelector('.mdhb-drawer');
  if (burger && drawer) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      document.body.classList.toggle('mdhb-lock', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Mobile drawer accordions (L1 then L2), one open at a time ---- */
  if (drawer) {
    var l1s = drawer.querySelectorAll('.mdhb-drawer__l1');
    l1s.forEach(function (l1) {
      var btn = l1.querySelector('.mdhb-drawer__l1-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !l1.classList.contains('is-open');
        l1s.forEach(function (other) {
          other.classList.remove('is-open');
          var otherBtn = other.querySelector('.mdhb-drawer__l1-btn');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          other.querySelectorAll('.mdhb-drawer__l2').forEach(function (l2) { l2.classList.remove('is-open'); });
        });
        if (willOpen) {
          l1.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      l1.querySelectorAll('.mdhb-drawer__l2').forEach(function (l2) {
        var l2btn = l2.querySelector('button.mdhb-drawer__l2-btn');
        if (!l2btn) return;
        l2btn.addEventListener('click', function () {
          var willOpen = !l2.classList.contains('is-open');
          l1.querySelectorAll('.mdhb-drawer__l2').forEach(function (other) {
            other.classList.remove('is-open');
            var ob = other.querySelector('button.mdhb-drawer__l2-btn');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            l2.classList.add('is-open');
            l2btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ---- Search icons: reuse the existing search popin (assets/md-search-popin.js) ---- */
  header.querySelectorAll('[data-mdhb-search-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer) {
        drawer.classList.remove('is-open');
        document.body.classList.remove('mdhb-lock');
      }
      if (typeof window.openSearchPopin === 'function') window.openSearchPopin();
    });
  });
})();
